/**
 * <hero-offer> — sections/hero-offer.liquid
 *
 * Starts the overlay and split layouts' reveal once their photograph has loaded, as live does: adds .is-revealed, and
 * section-hero-offer.css transitions the image fade and the copy's rise (overlay) or the image's slide (split) from
 * that class. The stacked layout has no reveal and needs nothing here.
 */
if (!customElements.get('hero-offer')) {
  customElements.define(
    'hero-offer',
    class HeroOffer extends HTMLElement {
      image = null;
      jump = null;
      jumpCleared = false;

      connectedCallback() {
        this.bindJump();

        if (!this.classList.contains('hero-offer--overlay') && !this.classList.contains('hero-offer--split')) return;

        this.image = this.querySelector('.hero-offer__image');

        if (!this.image || this.image.complete) {
          this.reveal();
          return;
        }

        this.image.addEventListener('load', this.onImageSettled);
        this.image.addEventListener('error', this.onImageSettled);
      }

      disconnectedCallback() {
        this.removeImageListeners();
        this.jump?.removeEventListener('focus', this.onJumpFocus);
        this.jump?.removeEventListener('change', this.onJumpChange);
      }

      bindJump() {
        this.jump = this.querySelector('[data-hero-jump]');
        this.jump?.addEventListener('focus', this.onJumpFocus);
        this.jump?.addEventListener('change', this.onJumpChange);
      }

      // The select shows its first option; clearing the choice once lets that option be picked too (a change event
      // never fires for the option that is already selected)
      onJumpFocus = () => {
        if (this.jumpCleared) return;

        this.jumpCleared = true;
        this.jump.selectedIndex = -1;
      };

      // Scrolls to the section whose id ends in the option's anchor, clear of the sticky header
      onJumpChange = () => {
        const target = document.querySelector(`[id^="shopify-section-"][id$="__${CSS.escape(this.jump.value)}"]`);
        if (!target) return;

        const header = document.querySelector('header');
        const covered = header ? header.getBoundingClientRect().bottom : 0;
        const top = target.getBoundingClientRect().top + window.scrollY - covered - 20;
        const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        window.scrollTo({ top, behavior: calm ? 'auto' : 'smooth' });
      };

      onImageSettled = () => {
        this.removeImageListeners();
        this.reveal();
      };

      removeImageListeners() {
        this.image?.removeEventListener('load', this.onImageSettled);
        this.image?.removeEventListener('error', this.onImageSettled);
      }

      reveal() {
        // Resolve the hidden start style first: a cached image can settle before the band's first style pass, and a
        // transition needs a before-change style to run from
        for (const element of this.querySelectorAll('.hero-offer__image, .hero-offer__copy, .hero-offer__cta')) {
          getComputedStyle(element).opacity;
        }

        this.classList.add('is-revealed');
      }
    },
  );
}
